<template>
  <base-dialog @cancel="cancelDialog" width="50%">
    <div slot="header">{{ params.title }}</div>
    <div slot="body">
      <a-form :form="form.fc">
        <a-form-item label="标题" v-bind="formItemLayout">
          <a-input v-decorator="decorators.topic" placeholder="请输入标题" />
        </a-form-item>
        <a-form-item label="消息内容" v-bind="formItemLayout">
          <a-textarea v-decorator="decorators.message" placeholder="请输入内容" />
        </a-form-item>
        <a-form-item label="发送对象" v-bind="formItemLayout">
          <user-select v-decorator="decorators.contacts" />
        </a-form-item>
        <a-form-item label="级别" v-bind="formItemLayout">
          <a-select v-decorator="decorators.priority" placeholder="请选择级别">
            <a-select-option v-for="(key, value) in priorities" :key="key" :value="value">
              {{ $t(`notificationPriority.${value}`) }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="通知类型" v-bind="formItemLayout">
          <a-select v-decorator="decorators.topic_type" placeholder="请选择通知类型" @change="handleTopicTypeChange">
            <a-select-option v-for="(key, value) in sendTypes" :key="key" :value="value">
              {{ $t(`system.notify.topic.type.${value}`) }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item v-if="canExpire" label="过期时间" v-bind="formItemLayout">
          <a-date-picker
            v-decorator="decorators.expired_at"
            show-time
            format="YYYY-MM-DD HH:mm:ss" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" :loading="loading" @click="handleConfirm">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import UserSelect from '@/components/UserSelect'
import { NOTIFICATION_PRIORITY, NOTIFICATION_SEND_TYPE } from '@/constants/notification'

export default {
  name: 'MessageSendDialog',
  components: {
    UserSelect,
  },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      priorities: NOTIFICATION_PRIORITY,
      sendTypes: NOTIFICATION_SEND_TYPE,
      form: {
        fc: this.$form.createForm(this),
      },
      topicType: '',
      decorators: {
        topic: [
          'topic',
          {
            validateFirst: true,
            rules: [
              { required: true, message: '标题不能为空' },
            ],
          },
        ],
        message: [
          'message',
          {
            rules: [
              { required: this.topicType === NOTIFICATION_SEND_TYPE.announcement, message: '消息内容不能为空' },
            ],
          },
        ],
        contacts: [
          'contacts',
          {
            validateFirst: true,
          },
        ],
        priority: [
          'priority',
          {
            initialValue: 'normal',
            validateFirst: true,
          },
        ],
        topic_type: [
          'topic_type',
          {
            initialValue: 'notice',
            validateFirst: true,
          },
        ],
        expired_at: [
          'expired_at',
          {
            validateFirst: true,
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 18,
        },
        labelCol: {
          span: 6,
        },
      },
    }
  },
  computed: {
    canExpire () {
      return this.topicType === NOTIFICATION_SEND_TYPE.announcement
    },
  },
  methods: {
    validateForm () {
      return new Promise((resolve, reject) => {
        this.form.fc.validateFields((err, values) => {
          if (!err) {
            resolve(values)
          } else {
            reject(err)
          }
        })
      })
    },
    handleTopicTypeChange (value) {
      this.topicType = value
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.validateForm()
        const data = {
          ...values,
        }
        this.loading = true
        await this.params.onSend?.(data)
        this.$message.success(this.$t('common.success'))
        this.cancelDialog()
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
